/**
 * Constantes de endpoints de la API
 * Centralizadas para facilitar mantenimiento y evitar errores de tipeo
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: 'app/login',
    SIGNUP: 'app/signup',
    PASSWORD: 'app/password',
    VALIDATE_CODE: 'app/validateCode',
    FORGOT_PASSWORD: 'app/forgot',
    UPDATE_PASSWORD: 'app/updatePassword',
  },
  USER: {
    PROFILE: 'app/auth/user',
    CUIT: 'app/cuit',
  },
  CROWDFUNDING: {
    PROJECTS: 'crowdfunding/projects',
    PROJECT_DETAIL: 'crowdfunding/project',
  },
  PLATFORM: {
    DASHBOARD: 'platform/dashboard',
    PORTFOLIO: 'platform/portfolio',
    MOVEMENTS: 'platform/movements',
    TRADING: 'platform/trading',
  },
} as const;

/**
 * Clave para el token de autenticación en localStorage
 */
export const AUTH_TOKEN_KEY = 'X-Auth-Token';

/**
 * Clave para el refresh token en localStorage
 */
export const REFRESH_TOKEN_KEY = 'refreshToken';





